<template>
  <b-modal :active.sync="active"
      has-modal-card full-screen :can-cancel="false">
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
          <p class="modal-card-title">{{ horseId ? 'Edición de Caballo' : 'Ingreso de Caballo' }}</p>
          </div>
        </div>
      </header>
      <section class="modal-card-body" >
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <h1 class="title is-5">Información Básica</h1>
            <b-field label="Nombre"
              :type="!isValid ? 'is-danger' : null"
              :message="!isValid ? ['El nombre es un campo requerido']:[]"
              label-position="inside">
              <b-input
                  type="text"
                  v-model="horse.name"
                  placeholder="Nombre de Caballo">
              </b-input>
            </b-field>
            <b-field grouped>
              <b-field label="Fecha de Nacimiento" label-position="inside" expanded>
                <b-datepicker
                    v-model="birthDate"
                    :first-day-of-week="1"
                    :month-names="$moment.months()"
                    :day-names="$moment.weekdaysShort()"
                    :show-week-number="true"
                    placeholder="Click para seleccionar"
                    icon="calendar-today">
                </b-datepicker>
              </b-field>
              <b-field label="Género" label-position="inside" expanded>
                <b-select v-model="horse.gender" placeholder="Seleccione un género" expanded>
                  <option
                      v-for="option in genders"
                      :value="option.code"
                      :key="option.code">
                      {{ option.name }}
                  </option>
                </b-select>
              </b-field>
            </b-field>

            <h1 class="title is-5">Genealogía</h1>
            <b-field grouped>
              <b-field label="Padre" label-position="inside" expanded>
                <horse-selector :has-create-parent-modal="true" :value="horse.father_id" type="autocomplete" :params="{'gender': 'M'}" @select="selectFather"/>
              </b-field>
              <b-field label="Madre" label-position="inside" expanded>
                <horse-selector :has-create-parent-modal="true" :value="horse.mother_id" type="autocomplete" :params="{'gender': 'F'}" @select="selectMother"/>
              </b-field>
            </b-field>

            <h1 class="title is-5">Escuela</h1>
            <b-field label="Lección" label-position="inside">
              <lesson-select :selected.sync="horse.lesson_id"/>
            </b-field>
            <b-field label="Jinete" label-position="inside">
              <rider-selector :value="horse.rider_id" @select="selectRider"/>
            </b-field>

            <b-field label="Activo">
              <b-switch v-model="horse.active">
                  {{horse.active ? 'Si' : 'No'}}
              </b-switch>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <div class="columns">
              <div class="column">
                <b-button expanded @click="cancel" :disabled="isLoading">Cerrar</b-button>
              </div>
              <div class="column">
                <b-button type="is-primary" expanded @click="save" :loading="isLoading">Guardar</b-button>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import HorseSelector from '@/components/HorseSelector'
import RiderSelector from '@/components/RiderSelector'
import LessonSelect from '@/components/LessonSelect'
import HorseService from '@/services/HorseService'

export default {
  components: {
    HorseSelector,
    LessonSelect,
    RiderSelector
  },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    horseId: {
      type: Number,
      required: false,
      default: null
    }
  },
  created () {
    if (this.horseId) {
      this.getHorse()
    }
  },
  data () {
    return {
      isLoading: false,
      genders: [
        { code: 'M', name: 'Macho' },
        { code: 'F', name: 'Hembra' }
      ],
      birthDate: null,
      submit: false,
      horse: {
        name: null,
        birth_date: null,
        gender: null,
        father_id: null,
        mother_id: null,
        lesson_id: null,
        rider_id: null,
        horse_type_id: 1,
        active: true
      }
    }
  },
  methods: {
    cancel () {
      this.birthDate = null
      this.submit = false
      this.horse = {
        name: null,
        birth_date: null,
        gender: null,
        father_id: null,
        mother_id: null,
        lesson_id: null,
        rider_id: null,
        horse_type_id: 1,
        active: true
      }
      this.$emit('update:horseId', null)
      this.$emit('update:active', false)
    },
    selectFather (data) {
      this.horse.father_id = data ? data.id : null
    },
    selectMother (data) {
      this.horse.mother_id = data ? data.id : null
    },
    selectRider (data) {
      this.horse.rider_id = data ? data.id : null
    },
    success (message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    },
    async getHorse () {
      let response = await HorseService.getHorse(this.horseId)
      let horse = response.data.data
      this.horse = JSON.parse(JSON.stringify(horse))
      this.birthDate = this.$moment(this.horse.birth_date, 'YYYY-MM-DD').isValid() ? this.$moment(this.horse.birth_date, 'YYYY-MM-DD').toDate() : null
    },
    async save () {
      this.submit = true
      if (this.isValid) {
        this.isLoading = true
        try {
          if (this.horseId) {
            await HorseService.updateHorse(this.horseId, this.horse)
            this.success('Caballo editado exitosamente', 'is-success')
          } else {
            await HorseService.createHorse(this.horse)
            this.success('Caballo registrado exitosamente', 'is-success')
          }
        } catch (error) {
          console.log(error)
          this.success('Ha ocurrido un error', 'is-danger')
        }

        setTimeout(() => {
          this.$emit('update:active', false)
          this.$emit('saved')
          this.isLoading = false
        }, 3000)
      }
    }
  },
  watch: {
    birthDate (data) {
      this.horse.birth_date = this.$moment(data).isValid() ? this.$moment(data).format('YYYY-MM-DD') : null
    },
    active (data) {
      if (this.active === true && this.horseId) {
        this.getHorse()
      }
    }
  },
  computed: {
    isValid () {
      return !((!this.horse.name || this.horse.length === 0) && this.submit)
    }
  }
}
</script>
